import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Input,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { EntityService, Constants, RequireMatch, Entity } from "../../../core";
import { takeUntil, startWith, map } from "rxjs/operators";
import { Subject, Observable } from "rxjs";

@Component({
  standalone: false,
  selector: "app-entity-autocomplete",
  templateUrl: "./entity-autocomplete.component.html",
})
export class EntityAutocompleteComponent implements OnInit, OnDestroy {
  @Input() placeholder: string = "Seleccione entidad *";
  @Output() onSelectEntity = new EventEmitter<any>();
  @Output() onResetEntity = new EventEmitter<boolean>();
  @Output() entitiesListed = new EventEmitter<Entity[]>();
  entityList: Entity[];
  listEntitiesAutocomplet: Observable<any[]>;
  private onDestroy$: Subject<void> = new Subject<void>();
  entityCode: FormControl = new FormControl();
  constructor(private entityService: EntityService) {
    this.entityCode.setValidators(RequireMatch);
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  getEntityList(type: string) {
    this.entityList = [];
    this.entityService.listEntity(type, true).subscribe((response: any) => {
      if (response && response.data && response.data.listEntities[0]) {
        this.entityList = response.data.listEntities.filter(
          (entity: Entity) => !!entity.active
        );
        this.entitiesListed.emit(this.entityList);
        this.showEntity();
      }
    });
  }

  displayFnEntity(entity): string {
    return entity ? (entity.entityName ? entity.entityName : entity) : null;
  }

  showEntity() {
    this.listEntitiesAutocomplet = this.entityCode.valueChanges.pipe(
      startWith(""),
      map((value) =>
        !value || typeof value === "string" ? value : value.entityName
      ),
      map((value) =>
        value ? this.filterEntity(value) : this.entityList.slice()
      )
    );
  }

  filterEntity(value) {
    const filterValue = value.toLowerCase();
    return this.entityList.filter(
      (item) =>
        item.entityName.toString().toLowerCase().indexOf(filterValue) >= 0
    );
  }

  cleanEntity() {
    this.entityCode.setValue(null);
    this.onResetEntity.emit(true);
  }

  changeSelectEntity() {
    this.onSelectEntity.emit(this.entityCode.value.entityCode);
  }

  setEntityCode(entityCode: string) {
    const entitySelected = this.entityList.find(entity => entity.entityCode === entityCode);
    if(entitySelected) {
       this.entityCode.setValue(entitySelected);
       this.changeSelectEntity();
    }
  }
}
